import {useMutation} from "@apollo/client";
import {CreateCredentialOptionsDocument} from "generated/graphql";

export const useCreateCredentialOptions = () => useMutation(CreateCredentialOptionsDocument);